import React from 'react'
import { observer } from 'mobx-react-lite'
import { IconButton } from '@mui/material'
import { Close } from '@mui/icons-material'

export const Exit = observer((props: any) => {
  const { onPress, color } = props
  return (
    <IconButton data-qat="exit-quiz" aria-label="exit quiz" role="link" onClick={onPress}>
      <Close htmlColor={color} />
    </IconButton>
  )
})
